import { useSharedState } from './useSharedState';

const SEARCH_OVERLAY = 'searchOverlay';

export const useOverlay = () => {
  const [isOverlayVisible, setIsOverlayVisible] = useSharedState<boolean>(SEARCH_OVERLAY, false);
  return { isOverlayVisible, setIsOverlayVisible };
};
